import _ from 'lodash'
import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'

Vue.use(Vuex)
Vue.use(VueResource)

const state = {
  locale: 'fr',
  document_is_ready: false,
  locale_is_ready: false,
  modal_contact_reason: '',
  show_navbar: true,
  show_footer: true,
  user_authentication_token: undefined,
  invalid_login_or_password: false,
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  show_navbar_and_footer(state, val) {
    state.show_navbar = val
    state.show_footer = val
  },
  contact(state, val) {
    state.modal_contact_reason = val
  },
  update_locale(state, val) {
    // console.log(val)
    let used_language = 'fr'
    if (!_.isNull(val)) {
      if (_.includes(['fr', 'en'], val)) {
        used_language = val
      }
      // console.log(JSON.parse(JSON.stringify(used_language)))
      window.localStorage.setItem('locale', JSON.stringify(used_language))
    }
    // console.log('store change locale', state.locale, used_language)
    // state.locale = used_language
    Vue.set(state, 'locale', used_language)
  },
  document_ready(state) {
    state.document_is_ready = true
    if (state.locale_is_ready) {
      // document.dispatchEvent(new Event('custom-post-render-event'))
    }
  },
  locale_ready(state) {
    state.locale_is_ready = true
    if (state.document_is_ready) {
      // document.dispatchEvent(new Event('custom-post-render-event'))
    }
  },
  set_user_authentication_status(state, payload) {
    state.user_authentication_token = payload
  },

  set_invalid_login_or_password(state, payload) {
    state.invalid_login_or_password = payload
  },
}

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
  init_locale({ commit }, payload) {
    // console.log("init_locale")
    if (navigator.userAgent === 'PhantomSynaplus') {
      commit('update_locale', payload.default_language)
      commit('locale_ready')
      return
    }
    let stored_language = null
    try {
      let candidate_language = window.localStorage.getItem('locale')
      if (!_.isNull(candidate_language)) {
        candidate_language = JSON.parse(candidate_language)
      }
      stored_language = candidate_language
    } catch (err) {
      // continue regardless of error
    }
    // const stored_language = null
    // const stored_language = JSON.stringify('fr')
    // console.log(stored_language)
    if (_.isNull(stored_language)) {
      stored_language = payload.default_language
    }
    commit('update_locale', stored_language)
    commit('locale_ready')
  },
  async ask_for_login({ commit }, { login, password }) {
    let res = false
    try {
      res = await axios.post('/api/login', JSON.stringify({ login, password }))
    } catch (err) {
      // continue regardless of error
    }
    if (res) {
      commit('set_user_authentication_status', res)
      commit('set_invalid_login_or_password', false)
    } else {
      commit('set_invalid_login_or_password', true)
    }
  },
}

// getters are functions
const getters = {
  // evenOrOdd: state => state.count % 2 === 0 ? 'even' : 'odd'
  user_is_authenticated(state) {
    return !_.isUndefined(state.user_authentication_token)
  },
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
})
